import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { PktrAppMenuService } from '@prospektr/pktr-app-menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CampaignService } from 'src/app/_shared/service/campaign.service';
import { EmailSubscribeService } from 'src/app/_shared/service/email-subscribe.service';
import { CampaignState } from 'src/app/_shared/state/campaign.state';
import { AppState } from 'src/app/app.state';
import { ValidatorsService } from 'src/app/shared/service/validators.service';
import constants from 'src/constant.json';

@Component({
  selector: 'app-status-campaign-sheet',
  templateUrl: './status-campaign-sheet.component.html',
  styleUrls: ['./status-campaign-sheet.component.scss'],
})
export class StatusCampaignSheetComponent implements OnInit, OnChanges {
  openStatusSheet: false;
  displayUnsubscribe = false;
  @Input() selectedStatus: any;
  @Input() campaignType: string;
  @Output() loadStatistics = new EventEmitter<void>();

  infoFetchParams = { limit: 10, offset: 0, searchQuery: null };
  onDestroyNotifier$ = new Subject();
  tableDataSource: any[] = [];
  tableColumnList: string[] = ['insertedDate', 'status', 'readCount', 'updatedDate', 'address'];
  reportId: string;
  isLoading: boolean = false;

  constructor(
    public campaignState: CampaignState,
    private campaignService: CampaignService,
    public appState: AppState,
    private router: Router,
    public emailSubscribeService: EmailSubscribeService,
    public _pktrAppMenuService: PktrAppMenuService,
    public breakpointService: ValidatorsService
  ) { }

  ngOnInit() {
    this.breakpointService
      .isMobileOrTablet()
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((isMobileOrTablet) => {
        if (isMobileOrTablet) {
          this._pktrAppMenuService.close(true);
        }

      });
  }

  ngOnChanges() {
    this.campaignState.openCampaignStatusSheetSub$.pipe().subscribe((res: any) => {
      this.openStatusSheet = res;
    });
    this.getCampaignReadInfo();
    this.getReportInfo();
  }

  getCampaignInfo() {
    let params = {
      createdUserId: this.selectedStatus.createdUserId,
      searchQuery: this.infoFetchParams.searchQuery,
      limit: this.infoFetchParams.limit,
      offset: this.infoFetchParams.offset,
      campaignId: this.selectedStatus.campaignId,
    };
    this.campaignService
      .getCampaignInfo(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.tableDataSource = res?.response?.records;
      });
  }

  getCampaignReadInfo() {
    let params = {
      campaignType: this.campaignType,
      userSubscriptionId: this.selectedStatus?.userSubscriptionId || this.selectedStatus?.userSubscriptionInfo?._id,
      searchQuery: this.infoFetchParams.searchQuery,
      limit: this.infoFetchParams.limit,
      offset: this.infoFetchParams.offset,
      messageId:
        this.appState?.appCompanyAliasValue === 'valuetest'
          ? null
          : this.selectedStatus?.type || this.selectedStatus?.userSubscription?.subscriptions?.type,
      //  this.selectedStatus?.type || `PROSPEKTR_${this.selectedStatus?.campaignType}`,
      userSubscriptionIdList: this.selectedStatus.subscriptionIds || [this.selectedStatus.userSubscriptionId],
      email: this.appState?.appCompanyAliasValue != 'valuetest' ? this.selectedStatus.email : null,
      userId: this.appState?.appCompanyAliasValue != 'valuetest' ? this.selectedStatus.userId : null,
    };
    this.campaignService
      .getCampaignReadInfo(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.displayUnsubscribe = res?.response?.displayUnsubscribe ? true : false;
        this.tableDataSource = res?.response?.records;
      });
  }

  getReportInfo() {
    let params = {
      createdUserId: this.selectedStatus.createdUserId,
      campaignId: this.selectedStatus.campaignId,
      pmxPropertyId:
        typeof this.selectedStatus.pmxPropertyId == 'number'
          ? this.selectedStatus.pmxPropertyId.toString()
          : this.selectedStatus.pmxPropertyId,
    };
    this.campaignService
      .getReportInfo(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        if (res && res?.response && (res.response?.compReportReferenceId || res.response?.expandedReportReferenceId)) {
          this.reportId = res.response._id;
        }
      });
  }

  viewReport() {
    this.close();
    this.router.navigate(['/reports/view'], {
      queryParams: {
        id: this.reportId,
        from: 'campaigns',
      },
    });
  }

  unsubscribeReport() {
    this.isLoading = true;
    const isValueTest = this.appState?.appCompanyAliasValue === 'valuetest';
    let params = {
      type: isValueTest
        ? constants.VALUETEST_REPORT_SHARING_CONFIG.campaignReportShare.messageId
        : this.selectedStatus?.type || null,
      emailAddress: this.selectedStatus?.email,
      ...(isValueTest && { campaignId: this.selectedStatus?.campaignId }),
    };

    this.emailSubscribeService
      .unsubscribe(params)
      .pipe()
      .subscribe((res: any) => {
        if (!res.isLoading) {
          this.loadStatistics.emit();
          this.close();
          this.isLoading = false;
        }
      });
  }

  close() {
    this.campaignState.openCampaignStatusSheetValue = false;
  }
}
